import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { DjayNarrator } from '../../mascot';
import { Chrome, RefreshCw } from 'lucide-react';
/**
 * UnsupportedBrowserScreen — Friendly Djay-styled fallback for browsers that
 * are too old to run the app (missing modern Web APIs like structuredClone,
 * globalThis, native async/await, etc.).
 *
 * Shown when boot detects a ReferenceError on a known modern global, or when
 * the explicit capability probe flags missing features.
 */
export function UnsupportedBrowserScreen({
  missingFeature
}: {
  missingFeature?: string;
}) {
  return <div className="min-h-screen w-full flex items-start sm:items-center justify-center px-4 py-8 bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50" data-id="element-2609" data-mp="3c19muuoimnox">
      <Card className="max-w-lg w-full p-8 sm:p-10 text-center bg-white/90 backdrop-blur border-2 border-orange-100 shadow-xl rounded-[2rem] relative overflow-hidden" data-id="element-2610" data-mp="32zju9liwdipk">
        <div className="absolute top-0 right-0 w-48 h-48 bg-orange-100/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-2611" data-mp="2y18kfaslr87c" />
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-amber-100/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4 pointer-events-none" data-id="element-2612" data-mp="16h8p1pfxdbtu" />

        <div className="relative z-10 flex flex-col items-center" data-id="element-2613" data-mp="snhfwi63vtyn">
          <div className="mb-5" data-id="element-2614" data-mp="xpgkfvdl0wx6">
            <DjayNarrator size="lg" emotion="sad" animate data-id="element-2615" data-mp="xmkh1riytg1c" />
          </div>

          <h1 className="text-2xl sm:text-3xl font-black text-slate-800 mb-3 tracking-tight" data-id="element-2616" data-mp="1leraoixb38x2">
            Hoi! Je browser is een beetje oud
          </h1>

          <p className="text-slate-600 mb-2 text-base leading-relaxed font-medium max-w-md" data-id="element-2617" data-mp="1bglac5r5eaub">
            Meester Djay werkt het beste in een{' '}
            <span className="font-bold text-slate-800" data-id="element-2618" data-mp="1gdbq0rz1j4f7">moderne browser</span>.
            Probeer een nieuwere versie van Chrome, Firefox, Safari of Edge.
          </p>

          <p className="text-slate-500 mb-6 text-sm leading-relaxed max-w-md" data-id="element-2619" data-mp="5115f8ugaelu">
            Vraag een ouder of leerkracht om je te helpen met updaten — dan
            kunnen we samen verder oefenen! 🚀
          </p>

          <div className="w-full bg-orange-50/80 border border-orange-100 rounded-2xl p-4 mb-6 text-left" data-id="element-2620" data-mp="3d2z68m6mjlk4">
            <div className="flex items-start gap-3" data-id="element-2621" data-mp="389ebd30bv7p5">
              <Chrome className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" data-id="element-2622" data-mp="33ce7myqyah17" />
              <div data-id="element-2623" data-mp="2ycrvytqrt8ui">
                <p className="text-sm font-semibold text-slate-700 mb-1" data-id="element-2624" data-mp="2ydb3dgisoeua">
                  Aanbevolen browsers
                </p>
                <p className="text-xs text-slate-600 leading-relaxed" data-id="element-2625" data-mp="2tc5758pxe9g0">
                  Chrome 98+, Firefox 94+, Safari 15.4+, Edge 98+ (vanaf 2022)
                </p>
              </div>
            </div>
          </div>

          <Button onClick={() => window.location.reload()} variant="primary" size="lg" className="shadow-lg rounded-2xl hover:shadow-xl transition-shadow w-full sm:w-auto" data-id="element-2626" data-mp="2kf3apkssjzox">
            <RefreshCw className="w-5 h-5 mr-2" data-id="element-2627" data-mp="q5fw6qmah1cg" />
            Probeer opnieuw
          </Button>

          {missingFeature && <p className="mt-4 text-[11px] font-mono text-slate-400 select-all" data-id="element-2628" data-mp="v37srxxvpbmz">
              Ontbrekende functie: {missingFeature}
            </p>}
        </div>
      </Card>
    </div>;
}